const STATES = {
  created: {
    name: "criado",
    color: "gray"
  },
  waiting: {
    name: "aguardando pagamento",
    color: "pink"
  },
  in_analysis: {
    name: "em análise",
    color: "pink"
  },
  cancelled: {
    name: "cancelado",
    color: "gray"
  },
  pre_authorized: {
    name: "pré-autorizado",
    color: "pink"
  },
  authorized: {
    name: "autorizado",
    color: "green"
  },
  settled: {
    name: "pago",
    color: "green"
  },
  refunded: {
    name: "reembolsado",
    color: "gray"
  },
  reversed: {
    name: "revertido",
    color: "gray"
  },
  available_for_withdrawal: {
    name: "pago",
    color: "green"
  },
  requested: {
    name: "requisitado",
    color: "pink"
  }
};

function getState(state) {
  return STATES[state];
}

export default {
  getState
};

// export default {
//   filters: {
//     showCreditCardNumber(cc) {
//       return (
//         cc.first6.substr(0, 4) +
//         " " +
//         cc.first6.substr(4, 6) +
//         "** **** " +
//         cc.last4
//       );
//     },

//     getPaymentLabel(payload) {
//       let status = STATES[payload];
//       return status ?
//         `<div class="label bg-${status.color}">${status.name}</div>` :
//         "";
//     }
//   }
// };



// WEBPACK FOOTER //
// ./src/utils/states/payment.js